import type { ErrorCopyFor } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";
import type { PROJECT_ERROR_CODES } from "@amtana/project-contract";

// What a user reads when a project action fails (packages/module ADR-001).

const EN = {
  limitReachedTitle: "You've reached your project limit",
  limitReachedDescription: "Archive a project or upgrade your plan to create more.",
  notFoundTitle: "This project doesn't exist",
  notFoundDescription: "It may have been archived. Pick another project, or show archived ones.",
  defaultProtectedTitle: "The default project can't be archived",
  defaultProtectedDescription: "Move what you need and archive another project instead.",
} as const;

const ES: Translation<typeof EN> = {
  limitReachedTitle: "Llegaste al límite de proyectos",
  limitReachedDescription: "Archiva un proyecto o mejora tu plan para crear más.",
  notFoundTitle: "Este proyecto no existe",
  notFoundDescription: "Puede que esté archivado. Elige otro proyecto o muestra los archivados.",
  defaultProtectedTitle: "El proyecto predeterminado no se puede archivar",
  defaultProtectedDescription: "Mueve lo que necesites y archiva otro proyecto.",
};

export const PROJECT_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const PROJECT_ERROR_COPY = {
  project_limit_reached: {
    title: phrase(PROJECT_ERROR_CATALOGS, "limitReachedTitle"),
    description: phrase(PROJECT_ERROR_CATALOGS, "limitReachedDescription"),
  },
  project_not_found: {
    title: phrase(PROJECT_ERROR_CATALOGS, "notFoundTitle"),
    description: phrase(PROJECT_ERROR_CATALOGS, "notFoundDescription"),
  },
  project_default_protected: {
    title: phrase(PROJECT_ERROR_CATALOGS, "defaultProtectedTitle"),
    description: phrase(PROJECT_ERROR_CATALOGS, "defaultProtectedDescription"),
  },
} satisfies ErrorCopyFor<typeof PROJECT_ERROR_CODES>;
